import { useTranslation } from '@eti/providers';
import Box from '../../../common/components/ProductBox';
import Description from '../../../common/components/ProductDescription';
import Imagery from '../../../common/components/ProductImagery';
import { jsx as _jsx } from "react/jsx-runtime";
const NotAvailableCheckInBaggage = ({
  shouldShowImage
}) => {
  const {
    t
  } = useTranslation();
  const title = t('checkInBaggageHeaderTitle');
  const description = t('Product.CheckInBaggage.Not.Included.Or.Sellable.Text');
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "not-available-included-baggage",
    children: /*#__PURE__*/_jsx(Box, {
      description: /*#__PURE__*/_jsx(Description, {
        description: description,
        productName: "checkInBaggage",
        shouldShowImage: shouldShowImage,
        title: title
      }),
      imagery: shouldShowImage && /*#__PURE__*/_jsx(Imagery, {
        productName: "checkInBaggage"
      })
    })
  });
};
export default NotAvailableCheckInBaggage;
//# sourceMappingURL=NotAvailableCheckInBaggage.js.map